document.addEventListener("DOMContentLoaded", () => {

	// Select the header element
	const header = document.querySelector(".header");

	// Initialize requestId variable
	let requestId;

	// Store the previous scroll position of the page
	let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;

	// Store the time when the header was scrolled up
	let headerScrollUpAddedAt = 0;

	// Store the time when the header was scrolled down
	let headerScrollDownAddedAt = 0;

	// Add scroll event listener to the window
	window.addEventListener("scroll", function() {

		// Cancel the previous requestAnimationFrame if there is any
		if (requestId) {
			window.cancelAnimationFrame(requestId);
		}

		// Request a new animation frame
		requestId = window.requestAnimationFrame(function() {

			// Get the height of the header element
			const headerHeight = header.getBoundingClientRect().height;

			// Get the current scroll position of the page
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			// If the header was scrolled down and the current scroll position is greater than the previous,
			// add the "header-scroll-up" class to the header
			if (headerScrollDownAddedAt - headerHeight > scrollTop) {
				header.classList.add("header-scroll-up");
				headerScrollUpAddedAt = prevScrollPos;
			}

			// If the header was scrolled up and the current scroll position is less than the previous,
			// remove the "header-scroll-up" class from the header
			else if (headerScrollUpAddedAt + headerHeight < scrollTop) {
				header.classList.remove("header-scroll-up");
			}

			// If the current scroll position is greater than the header height,
			// add the "header-sticky" class to the header
			if (scrollTop > headerHeight) {
				header.classList.add("header-sticky");
			}

			// If the current scroll position is less than or equal to the header height,
			// remove both "header-sticky" and "header-scroll-up" classes from the header
			else {
				header.classList.remove("header-sticky");
				header.classList.remove("header-scroll-up");
			}

			// If the current scroll position is greater than the previous,
			// store the previous scroll position as header scrolled down
			if(scrollTop > prevScrollPos) {
				headerScrollDownAddedAt = prevScrollPos;
			}

			// Update the previous scroll position with the current scroll position
			prevScrollPos = scrollTop;
		});
	}, false);

	// Select the search button, close button, search section, and input field
	var searchButton = document.querySelector('.header-3 .button.search');
	var closeButton = document.querySelector('.header-3 .button.close');
	var searchSection = document.querySelector('.header-3 > .search');
	var searchInput = document.querySelector('.header-3 > .search input[type="search"]');
	var searchBackground = document.querySelector('.header-3 > .search .background');

	// Function to toggle search section and button classes
	function toggleSearch() {
		// Toggle visibility of search section
		searchSection.classList.toggle('active');

		// Toggle 'active' class on the search button and close button
		searchButton.classList.toggle('active');
		closeButton.classList.toggle('active');

		// If the search section is now visible, focus the input field
		if (searchSection.classList.contains('active')) {
			searchInput.focus();
		} else {
			searchInput.blur(); // Optionally remove focus from input when closing
		}

		// Add event listener to the background layer
		searchBackground.addEventListener('click', function(event) {
			toggleSearch();
		});
	}

	// Add event listener to the search button
	if ( searchButton ) {
		searchButton.addEventListener('click', function(event) {
			event.preventDefault(); // Prevent default anchor behavior
			toggleSearch();
		});
	}

	// Add event listener to the close button
	if ( closeButton ) {
		closeButton.addEventListener('click', function(event) {
			event.preventDefault(); // Prevent default anchor behavior
			toggleSearch();
		});
	}
});